import React, { useState } from 'react';

const PasswordResetModal = ({ onClose, identifier }) => {
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  // Handle password reset submission
  const handlePasswordResetSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    const requestBody = {
      username: identifier,  // Using identifier as the username
      newPassword: newPassword,
      confirmPassword: confirmPassword,
      otp: otp,
    };

    // Log the request body before sending the request
    console.log('Request Body:', requestBody);

    try {
      const response = await fetch('http://localhost:7254/auth/resetNewPassword', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('Password reset successful',data);
        onClose(); // Close the modal on success
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to reset password');
      }
    } catch (error) {
      console.error('Error during password reset:', error);
      setError('An unexpected error occurred');
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg">
        <h2 className="text-xl font-bold mb-4">Reset Password</h2>
        <form onSubmit={handlePasswordResetSubmit}>
          <div className="mb-4">
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="border border-gray-300 rounded-lg py-2 px-4 w-full"
              required
            />
          </div>
          <div className="mb-4">
            <input
              type="password"
              placeholder="Enter New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="border border-gray-300 rounded-lg py-2 px-4 w-full"
              required
            />
          </div>
          <div className="mb-4">
            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="border border-gray-300 rounded-lg py-2 px-4 w-full"
              required
            />
          </div>
          {error && (
            <p className="text-red-500 text-sm mb-4">{error}</p>
          )}
          <button
            type="submit"
            className="bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition duration-200 w-full"
          >
            Reset Password
          </button>
        </form>
        <button
          className="mt-4 text-gray-500 hover:underline"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default PasswordResetModal;
